import { render, staticRenderFns } from "./AddUpdateService.vue?vue&type=template&id=126c7d98"
import script from "./AddUpdateService.vue?vue&type=script&lang=js"
export * from "./AddUpdateService.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateService.vue?vue&type=style&index=0&id=126c7d98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports